window.RakutenConstants = ({
    constants: {
        emailIdRegex:
            new RegExp(/^[a-zA-Z0-9.%+_-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
    },
    gtm: {
        event: {
            signUpResult: 'signupResult',

        },
        result: {
            success: 'signupSuccessful',
            error: 'signupError',
            errorResult: 'Error Code is: '
        }
    },
    notificationCategories: {
        enrolment: 'Enrolment'
    },
    elements: {
        id: {
            hasRakutenAccount: '#rakuten-account-yes',
            hasNoRakutenAccount: '#rakuten-account-no',
            rakutenSignUpForm: '#rakuten-signup-form',
            rakutenRegistrationForm: '#rakuten-registration-form',
            registeredEmailId: '#registered-email-id',
            enrolmentError: '#enrolment-error',
            unenrolmentErrorModal: 'unenrolment-error-modal',
            unenrolmentLoadingModal: 'unenrolment-loading-modal',
            hasHealthReviewToggle: '#health-review-toggle-off',
            hasNoHealthReviewToggle: '#health-review-toggle-on'
        },
        classes: {
            radioButton: '.vds-form__radio',
            rakutenCheckboxGuard: '.rakuten-checkbox-guard',
            textBoxError: '.vds-form__input--invalid',
            notificationsPageLevel: '.vds-notification--page-level',
            primaryContainer: '.vds-main-content__primary-container',
            activateBenefitCTA: '.activate-benefit'
        },

        buttons: {
            signUpButton: '#sign-up-button',
            unenrolmentErrorModelClose: '#unenrolment-error-modal .vds-modal__close',
            confirmDelink: '#confirm-delink',
            pleaseWaitButton: '#please-wait-button'
        },
        checkboxes: {
            benefitCheckBoxes: '.rakuten-benefit-checkbox',
            partnerTermsCheck: '#partner-terms-check'
        }
    },
    urls: {
        enrolMember: '/api/sitecore/ComplianceInformation/Enrol',
        partnerNotification: '/api/sitecore/PartnerNotification/PartnerNotification',
        errorPage: '/error/error-page',
        unenrolMember: '/api/sitecore/AccountInformation/Unenrol'
    }
});
